import { Button } from "@/components/ui/button";

export function ConflictBanner({ onRefresh }: { onRefresh: () => void }) {
	return (
		<div
			data-testid="conflict-banner"
			className="bg-amber-100 border-b border-amber-300 px-4 py-2 flex items-center justify-center gap-3 text-sm text-amber-900"
		>
			<span>This item was modified by another user.</span>
			<Button variant="outline" size="sm" onClick={onRefresh}>
				Refresh
			</Button>
		</div>
	);
}
